module.exports = __webpack_public_path__ + "img/logo.3ccb2efc.png";